import React from 'react'
import classNames from 'classnames'
import { StateProvider } from '../../core'

import './modal.scss'

class Modal extends React.Component {
  componentWillUnmount() {
    document.body.style.overflow = 'auto'
  }
  
  render() {
    const { 
      isActive, 
      onClose, 
      theme,
      children, 
    } = this.props

    if (!isActive) {
      return null
    }

    const handleClose = () => {
      document.body.style.overflow = 'auto'
      onClose()
    }

    return (
      <StateProvider>{( isAnimated, setAnimated) => {
        const modalWrapperClass = classNames(
          'modal-wrapper',
          theme && `theme-${theme}`,
          isAnimated && 'has-animated'
        )

        const modalClass = classNames(
          'modal',
          isAnimated && 'has-animated'
        )

        if (!isAnimated) {
          setTimeout(() => setAnimated(true), 0)
        }
    
        return (
          <div styleName={`${modalWrapperClass} `}>
            <div styleName={`${modalClass}`}>
              <div onClick={handleClose} styleName='close-modal'>✕</div>
              {children}
            </div>
          </div>
        )
      }}</StateProvider>
    )
  }
}

export default Modal